import Component from './component';
import quickviewHelper from '../helpers/quickviewhelper';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');

export default class quickView extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }

    getModalContent(url) {
        fetch(url + '&showQuickView=true', {
            method: 'GET',
            headers: { 'Content-type': 'application/json;charset=UTF-8', 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then((response) => response.json())
            .then((data) => {
                this.setState(data);
            });
    }

    getCQViewproductActivity() {
        if (this.el.dataset.activityUrl) {
            const pid = (new URL(location.origin + this.el.dataset.modalUrl)).searchParams.get('pid');
            var scriptContainer = this.$el.find('.CQviewproductScript');
            fetch(this.el.dataset.activityUrl + `?pid=${pid}`)
            .then((response) => {
                return response.text().then(data => {
                    scriptContainer.empty().html(data);
                });
            });
        }
    }

    openModal() {
        if ($('.product-set-detail').length) {
            $('body').append(quickviewHelper.getModalHtmlElementSet(`${this.name}Modal`));
        } else {
            $('body').append(quickviewHelper.getModalHtmlElement(`${this.name}Modal`));
        }
        this.getModalContent(this.el.dataset.modalUrl);
    }

    render() {
        const data = this.state;
        const $container = $(`#${this.name}Modal`);
        const recommendationContainer = this.$el.closest('div[data-recomtype]');
        const recommendationContainerType = recommendationContainer ? recommendationContainer.data('recomtype') : '';
        let searchRedirect;
        let productTileIndex;
        var pdeinsteinctlflag = this.$el.closest('.experience-einstein-pvhEinsteinCarouselCategory').length;
        var pdeincarousel = this.$el.closest('.experience-einstein-pvhEinsteinCarousel').length;
        if (pdeinsteinctlflag || pdeincarousel) {
            productTileIndex = this.$el.closest('.pd-einsteinReco-product-tile').data('position') + 1;
            searchRedirect = this.$el;
        } else {
            productTileIndex = this.$el.closest('.productTileShow').data('productindex');
            searchRedirect = this.$el.closest('div.quickview').data('searchcheck');
        }
        this.getCQViewproductActivity();
        var splitText = window.PVH.customer && window.PVH.customer.customerGroups ? window.PVH.customer.customerGroups.split(',') : [];
        var isCustomerAuthenticated = splitText.includes('authenticatedusers');
        quickviewHelper.renderQuickView(data, $container, recommendationContainerType, true);
        // tealium event
        $('.isauthenticated').data('isauthenticated', isCustomerAuthenticated);
        if (data.product.isMembersOnly && !isCustomerAuthenticated) {
            $('.login-acc-container.member-signin-link').removeClass('d-none');
            $('button.add-to-cart-global').addClass('d-none');
        } else if (data.product.isMembersOnly && isCustomerAuthenticated) {
            $('.login-acc-container.member-signin-link').addClass('d-none');
            $('button.add-to-cart-global').removeClass('d-none');
        } else {
            $('.login-acc-container.member-signin-link').addClass('d-none');
            $('button.add-to-cart-global').removeClass('d-none');
        }
        if (pdeinsteinctlflag || pdeincarousel) {
            let pdeinsteinctltype = 'pdeinstein-carousel';
            tealiumEnable.getAnalyticsData('quickViewEvent', data, productTileIndex, searchRedirect, pdeinsteinctltype);
        } else {
            tealiumEnable.getAnalyticsData('quickViewEvent', data, productTileIndex, searchRedirect);
        }
    }

    enable() {
        // click binding on modal button
        $(this.$el).on('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (this.el.dataset.stayopen === 'true') {
                $(`#${this.el.dataset.comp}Modal .modal-dialog`).spinner().start();
                this.getModalContent(this.el.dataset.modalUrl);
                this.el.scrollIntoView({ block: 'center' });
            } else {
                this.openModal();
            }
        });

        $(this.$el).on('keyup', (event) => {
            if (event.key === 'Enter' && this.el.dataset.stayopen) {
                $(this.$el).trigger('click');
            }
        });

        // remove modal once closed
        $('#quickViewModal').on('hidden.bs.modal', (event) => {
            $(event.target).remove();
        });
    }
}
